<template>
	<div class="generalization-box">
		<el-dialog
			:title="$t('generalization.detailTitle')"
			:visible.sync="detailDialogVisible"
			:center="true"
			:show-close="false"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			custom-class="detail-dialog"
		>
			<GeneralizationDetail :data="sendMessage" :height="height" @close-dialog="handleCloseDetailDialog" @send="handleOpenSendDialog" />
		</el-dialog>

		<div class="title">{{ $t("generalization.listTitle") }}</div>
		<div class="main-part">
			<el-input
				:placeholder="$t('generalization.searchPlaceholder')"
				clearable
				size="small"
				v-model="searchKeyword"
				@focus="onFocus"
				class="search-box"
				@clear="handleClear"
			>
				<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
			</el-input>

			<div class="list" :style="{ height: height + 'px' }">
				<div v-if="isShowGeneralizations" style="margin-top: 10px">
					<div v-for="customer in data" v-bind:key="customer.customer_id">
						<div v-if="customer.rmsPromotion.length != 0">
							<el-card>
								<div slot="header">
									<span>{{ customer.customer_id }}</span>
								</div>
								<div v-for="item in customer.rmsPromotion" v-bind:key="item.id" class="item">
									<el-tooltip effect="dark" :content="item.title" placement="top-start">
										<div class="text">{{ item.title }}</div>
									</el-tooltip>
									<div class="button-box">
										<el-button @click="handleCheckOut({ ...item, name1: customer.name1, customer_id: customer.customer_id })" size="mini">{{
											$t("generalization.checkOut")
										}}</el-button>
										<el-button
											@click="handleOpenSendDialog({ ...item, name1: customer.name1, customer_id: customer.customer_id })"
											size="mini"
											:plain="item.is_send"
											:type="item.is_send ? 'default' : 'primary'"
											>{{ item.is_send ? $t("generalization.sendAgain") : $t("generalization.send") }}</el-button
										>
									</div>
								</div>
							</el-card>
						</div>
					</div>
				</div>
				<div v-else class="no-data">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
import GeneralizationDetail from "./generalization-detail.vue";

export default {
	name: "GeneralizationList",
	components: {
		GeneralizationDetail,
	},
	props: {
		detailDialogVisible: {
			type: Boolean,
			default: false,
			required: true,
		},
		data: {
			type: Array,
			required: true,
		},
		loading: {
			type: Boolean,
			required: false,
			default: false,
		},
		height: {
			type: Number,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			beingViewedMessage: {},
			sendMessage: {},
			searchKeyword: "",
		};
	},

	methods: {
		handleSearch() {
			this.$emit("search", this.searchKeyword);
		},
		handleClear() {
			this.searchKeyword = "";
			this.$emit("search", "");
		},
		handleCheckOut(item) {
			this.sendMessage = item;
			this.$emit("update:detailDialogVisible", true);
		},
		handleOpenSendDialog(item) {
			this.$emit("openSendDialog", item);
		},
		//对话框搜索获取焦点
		onFocus() {
			this.isSearchFocused = true;
		},
		handleCloseDetailDialog() {
			this.$emit("update:detailDialogVisible", false);
		},
	},
	computed: {
		isShowGeneralizations: function () {
			if (this.data.length > 0) {
				return this.data.some((item) => Array.isArray(item.rmsPromotion) && item.rmsPromotion.length > 0);
			}
			return false;
		},
	},
};
</script>

<style lang="less" scoped>
.generalization-box {
	border: 1px solid #ebeef5;
	/deep/ .detail-dialog {
		width: 400px;
	}
	/deep/ .el-dialog__body {
		padding: 14px 0px 14px 0px !important;
	}
	.title {
		padding: 14px 1em;
		font-size: 14px;
		border-bottom: 1px solid #dcdcdc;
		color: #666666;
		font-weight: bold;
		background: #f5f7fa;
	}
	.main-part {
		.search-box {
			width: 94%;
			padding: 0px 3%;
			margin-top: 10px;
		}
		.list {
			// padding: 0 10px;
			overflow-y: auto;
			scrollbar-width: none;
			/deep/ .el-card__body {
				padding: 0 20px;
			}
			.no-data {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #929292;
				font-size: 16px;
			}
			.customer-id {
				padding: 14px 10px;
				position: sticky;
				top: 0;
				background: #fff;
				font-size: 18px;
				color: #666666;
				border-top: 1px solid #dcdcdc;
				border-bottom: 1px solid #dcdcdc;
			}
			.item {
				font-size: 14px;
				margin: 0px 10px;
				padding: 15px 0px;
				border-bottom: 1px solid #f2f0f0;
				color: #929292;
				.text {
					word-break: break-all;
					// white-space: nowrap; /* 禁止换行 */
					// overflow: hidden; /* 超出隐藏 */
					// text-overflow: ellipsis; /* 显示省略号 */
				}
				.button-box {
					margin-top: 10px;
					display: flex;
					justify-content: flex-end;
					align-items: center;
				}
			}
		}
		.list .item:last-child {
			border-bottom: none;
		}
	}
	.send-dialog-body {
		padding: 14px 30px;
	}
}
</style>
